/* eslint-disable react/jsx-no-target-blank */
import { IAdFoxBannerContext } from '@cian/adfox/build/react';
import * as React from 'react';

import * as styles from './styles.css';

export interface ITgbExtendedProps {
  context: IAdFoxBannerContext;
}

export class TgbExtended extends React.PureComponent<ITgbExtendedProps, {}> {
  public render() {
    const { context } = this.props;

    return (
      <a href={context.url} target="_blank" rel="nofollow noopener" className={styles['link']}>
        <div className={styles['container']}>
          <div className={styles['image']}>
            <img src={context.bgImageUrl} alt={context.title} />
          </div>
          <div className={styles['aside']}>
            <div className={styles['content']}>
              <h4 className={styles['title']}>{context.title}</h4>
              <p className={styles['text']}>{context.description}</p>
              {context.phone && <div className={styles['phone']}>{context.phone}</div>}
              {context.address && <div className={styles['address']}>{context.address}</div>}
            </div>
            {context.note && <div className={styles['note']}>{context.note}</div>}
          </div>
          <div className={styles['advanced']}>
            <span>Реклама</span>
            <span>Подробнее</span>
          </div>
        </div>
      </a>
    );
  }
}
